import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FolderKanban, FileText, ShoppingCart, Plus } from 'lucide-react';

const ROLES = ['super_admin', 'admin', 'office_admin', 'project_manager', 'project_manager_estimator', 'dispatch', 'fabrication_manager', 'shop_foreman'];
const BOOKS = [
  { key: 'work_orders', label: 'Work Orders', path: '/projects', icon: FolderKanban, perm: 'projects', newTitle: 'New work order' },
  { key: 'quotes', label: 'Quotes', path: '/quotes', icon: FileText, perm: 'quotes', newTitle: 'New quote' },
  { key: 'purchase_orders', label: 'POs', path: '/purchase-orders', icon: ShoppingCart, perm: 'purchase_orders', newTitle: 'New purchase order' },
];

/** The three fiscal-year books — click opens the list, the + half starts a new one. Shown to office / PM / dispatch / shop roles. */
export const QuickLaunch = ({ user }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const perms = user?.extra_permissions || [];
  const books = BOOKS.filter(b => ROLES.includes(user?.role) || perms.includes(b.perm));
  if (!books.length) return null;
  return (
    <div className="hidden md:flex items-center gap-1.5" data-testid="quick-launch">
      {books.map(b => {
        const active = pathname.startsWith(b.path);
        const Icon = b.icon;
        return (
          <div key={b.key} className={`inline-flex items-stretch rounded-full border shadow-sm overflow-hidden transition-colors ${active ? 'bg-slate-900 border-slate-900 text-white' : 'bg-white/90 border-slate-200 text-slate-800 hover:border-sky-300'}`} data-testid={`quick-${b.key}`}>
            <button onClick={() => navigate(b.path)} className={`h-8 pl-3 pr-2.5 inline-flex items-center gap-1.5 text-xs font-bold whitespace-nowrap ${active ? 'hover:bg-sky-800' : 'hover:bg-sky-50'}`} data-testid={`quick-${b.key}-list`}>
              <Icon className={`w-3.5 h-3.5 ${active ? 'text-sky-300' : 'text-sky-700'}`} /> {b.label}
            </button>
            <button onClick={() => navigate(`${b.path}?new=1`)} title={b.newTitle} className={`h-8 w-8 inline-flex items-center justify-center border-l ${active ? 'border-white/15 hover:bg-sky-800' : 'border-slate-200 hover:bg-sky-50 text-sky-700'}`} data-testid={`quick-${b.key}-new`}>
              <Plus className="w-3.5 h-3.5" />
            </button>
          </div>
        );
      })}
    </div>
  );
};
